import * as PIXI from 'pixi.js';
import gsap from 'gsap';

import { findCardContainer, CARD_HEIGHT } from '../utils/commonUtils';
import AssetsLoader from '../utils/assetsLoader';

export default async function (scene, gameState) {
    const { sourceCardId, stepResults } = gameState.pendingAction.context;
    const [targetCardId] = stepResults.chooseTarget;

    if (!targetCardId) {
        return;
    }

    const sourceCardContainer = findCardContainer(scene, sourceCardId);
    const targetCardContainer = findCardContainer(scene, targetCardId);

    const swirlStartPosition = sourceCardContainer.getGlobalPosition();
    const swirlEndPosition = targetCardContainer.getGlobalPosition();

    const mainCardContainer = new PIXI.Container();
    mainCardContainer.x = swirlStartPosition.x;
    mainCardContainer.y = swirlStartPosition.y - sourceCardContainer.scale.y * (CARD_HEIGHT / 2);
    mainCardContainer.alpha = 0;
    mainCardContainer.scale.set(0.2);
    scene.addChild(mainCardContainer);

    const img1 = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.ST03001_ANIMATION_1));
    img1.anchor.set(0.5);
    img1.zIndex = 3;
    mainCardContainer.addChild(img1);

    const img2 = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.ST03001_ANIMATION_2));
    img2.anchor.set(0.5);
    img2.zIndex = 2;
    mainCardContainer.addChild(img2);

    const img3 = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.ST03001_ANIMATION_3));
    img3.anchor.set(0.5);
    img3.zIndex = 1;
    mainCardContainer.addChild(img3);

    const ticker = new PIXI.Ticker();
    ticker.add(({ deltaTime }) => {
        img1.rotation -= deltaTime * 0.05 * 2;
        img2.rotation -= deltaTime * 0.1 * 2;
        img3.rotation -= deltaTime * 0.1 * 2;
    });
    ticker.start();

    const timeline = gsap.timeline();
    timeline.to(mainCardContainer, {
        duration: 0.5,
        ease: 'power2.out',
        pixi: {
            alpha: 1,
            scale: 0.85,
        }
    });

    timeline.to(mainCardContainer, {
        duration: 0.7,
        ease: 'power2.inOut',
        pixi: {
            x: swirlEndPosition.x,
            y: swirlEndPosition.y - targetCardContainer.scale.y * (CARD_HEIGHT / 2),
        }
    });

    await timeline;

    gsap.timeline().to(mainCardContainer, {
        duration: 0.5,
        ease: 'power2.out',
        pixi: {
            alpha: 0,
            scale: 1.3,
        }
    }).then(() => {
        ticker.destroy();
        mainCardContainer.destroy({ children: true });
    });
}